import SkeletonCard, { GridStatsCard } from '@/components/shared/GridStatsCard';
import { useAppSelector } from '@/hooks/redux';
import { USDDollarFormatter } from '@/utils/formatter';

const LandingDataStats: React.FC = () => {
  const loanStatistics = useAppSelector((state) => state.loans.loanStatistics);
  const loanStatisticsLoading = useAppSelector((state) => state.loans.loanStatisticsLoading);

  const stats = [
    {
      name: 'Active Loans',
      value: loanStatistics?.activeLentCount || 0,
    },
    {
      name: 'Total Loans',
      value: loanStatistics?.totalLentCount || 0,
    },
    {
      name: 'Defaulted Loans',
      value: loanStatistics?.foreclosedLentCount || 0,
    },
    {
      name: 'Default Rate',
      value: `${loanStatistics?.defaultLentRate.toFixed(2)}%`,
    },
    {
      name: 'AVG LTV',
      value: `${loanStatistics?.avgLtvLent.toFixed(2)}%`,
    },
    {
      name: 'AVG Duration ',
      value: `${loanStatistics?.avgDuration.toFixed(2)} days`,
    },
    {
      name: 'Daily Accrued Interest',
      value: USDDollarFormatter(loanStatistics?.dailyInterestAmountLent || 0),
      price: true,
    },
    {
      name: 'Outstanding Accrued Interest',
      value: USDDollarFormatter(loanStatistics?.outstandingInterestAmountLent || 0),
      price: true,
    },
    {
      name: 'Outstanding WAVG APR',
      value: `${loanStatistics?.outstandingWavgApr.toFixed(2)}%`,
      price: true,
    },
    {
      name: 'Realized WAVG APR',
      value: `${loanStatistics?.realizedWavgApr.toFixed(2)}%`,
      price: true,
    },
    {
      name: 'Total Lent',
      value: USDDollarFormatter(loanStatistics?.lent || 0),
      price: true,
    },
    {
      name: 'Total Earned',
      value: USDDollarFormatter(loanStatistics?.earnedAmount || 0),
      price: true,
    },
  ];

  return (
    <div className='flex flex-col gap-7 lg:flex-row justify-between items-center pb-7 lg:p-7 pt-0 lg:pt-0 max-lg:px-6 border-b'>
      <div className='grid grid-cols-6 w-max'>
        {loanStatisticsLoading
          ? new Array(12).fill(null).map((_, idx) => {
              return <SkeletonCard key={idx} />;
            })
          : stats.map(({ name, value, price }) => <GridStatsCard key={name} title={name} value={value} price={price} className='min-h-[91px] max-w-[157px]' />)}
      </div>
    </div>
  );
};

export default LandingDataStats;
